import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import format from 'date-fns/format';
import { Tab, Tabs } from '@dbk/ui-tabs';
import ReportRMDocList from '../report-rm-doclist/report-rm-doclist';
import SortingHeader from '../../../../../../src/components/common/sorting-header';
import DateSelectionBar from '../../../../../../src/components/common/date-selection-bar';
import CalendarModal from '../../../../../../src/components/common/calendar-modal';
import SimpleDate from '../../../../../../src/components/common/date';
import styles from './report-rm-details.style';
import { SELECTED_RANGE, DURATION, DATE_RANGE } from '../constants';
import { DatePicker, Utils } from '@dbk/ui-datepicker';
import InverseProvider from '@dbk/ui-inverse';
import 'moment/min/locales';
import moment from 'moment';
import { LoadingCircle } from '../../../../../../src/components/common/loading';
// import Button from '@dbk/ui-buttons';

class ReportRMDetails extends Component {
  constructor(props) {
    super(props);
    const languageCode = this.props.auth.langCode;
    const { startDate, endDate } = this.props.reports;
    Utils.configLocale(languageCode, {
      week: {
        dow: 1, // Monday is the first day of the week.
        // dow: 0, // Sunday is the first day of the week.
      },
    });
    const currentDate = moment();
    const firstDayOfYear = moment().startOf('year');
    const range = this.props.reports.selectedReportDetailsDateRange === 2;
    this.state = {
      isDateRangeSelected: range,
      totalDocs7Days: 0,
      totalDocs30Days: 0,
      totalDocsCustomRange: 0,
      value: {
        from: startDate? moment(startDate) : firstDayOfYear,
        to: endDate? moment(endDate) : currentDate
      },
    }


  }

  componentWillMount() {
    if (this.props.reports.openDateRangeTab) {
      this.props.setDataForNotificationList();
    }
  }

  componentDidUpdate() {

    if (this.props.reports.closeDatePicker === true
      && this.datepickerRef && this.datepickerRef.datepicker
      && this.datepickerRef.datepicker.state
      && this.datepickerRef.datepicker.state.isOpen) {
      this.onCancel();
    }
  }


  handleSelectedIndexClicked = (index) => {
    this.setState({
      isDateRangeSelected: false,
    });
    switch (index) {
      case 0:
        //    this.props.setRange7Days();
        break;
      case 1:
        //    this.props.setRange30Days();
        break;
      case 2:
        // this.props.setRangeYTD();
        // this.props.reports.calendar.open();
        this.setState({
          isDateRangeSelected: true,
        });
        break;
      default:
        break;
    }
    this.props.setReportDetailDateRange(index);
    this.setDuration(index);
  }

  /**
 * function to set duration week/month/dates
 */
  setDuration = (index) => {
    let duration = '';
    switch (index) {
      case 0:
        duration = DURATION.LAST_WEEK;
        break;
      case 1:
        duration = DURATION.LAST_MONTH;
        break;
      case 2:
        duration = DURATION.DATES;
        break;
      default:
        duration = '';
        break
    }

    this.props.setDuration(duration);
  }


  onDayClick = (selectionStart) => {
    const value = Utils.addDayToRange(
      selectionStart,
      this.state.value
    );
    this.setState({
      value,
    });
  };

  onChangeRange = (range) => {
    this.setState({
      value: {
        ...Utils.updateRangeWithReset(this.state.value, range)
      }
    });
  }

  onApplyDateChange = () => {
    this.onCancel();
    this.props.fetchDocumentsForCategories(this.state.value.from.format('YYYY-MM-DD'),
      this.state.value.to.format('YYYY-MM-DD'));
  }

  onCancel = () => {
    this.datepickerRef.datepicker.closeCalendar();
    this.props.setDatePickerClose(false);
  }

  customFooter = () => {
    const { i18n: { messages } } = this.props;
    return <InverseProvider inverse style={{ borderBottom: "1px solid #535b61", width: "100%", height: "60px", backgroundColor: '#12213c', paddingTop: "15px" }} >
      <div className='datepicker-footer-txt'>
        <Text style={{ padding: "5px" }}>{messages['app.chedelivery.reports.customReports.today']}{moment().format('DD-MMM-YYYY')}</Text>
      </div>
      <div className='datepicker-footer-btn'>
        <Button tertiary
          onClick={() => this.onCancel()}
        >{messages['app.chedelivery.reports.customReports.cancelButton']}</Button>

        <Button
          disabled={!(this.state.value.from && this.state.value.to)}
          onClick={() => this.onApplyDateChange()}
        >{messages['app.chedelivery.reports.apply']}</Button>
      </div>
    </InverseProvider>
  }

  render() {
    const { i18n: { messages },
      reports: { showSpinner, startDate, endDate, selectedReportDetailsDateRange, totalDocs30Days, totalDocs7Days, totalDocsCustomRange } } = this.props;
    let customRangeTotalDocs = '';
    if (totalDocsCustomRange > 0 && startDate) {
      customRangeTotalDocs = ` (` + totalDocsCustomRange + `)`;
    }

    /* Defining completeDate to format the startDate and endDate */
    let completeDate;
    if (startDate === endDate) {
      completeDate = <div><SimpleDate value={format(startDate, 'DD MMMM YYYY')} /></div>;
    } else if (startDate !== undefined && startDate.length !== 0 && endDate !== undefined && endDate.length !== 0) {
      completeDate = <div><SimpleDate value={format(startDate, 'DD MMMM YYYY')} /> - <SimpleDate value={format(endDate, 'DD MMMM YYYY')} /></div>;
    }

    return (
      <View style={styles.container}>

        <div>
          <View style={{ marginLeft: 20, marginRight: 20 }}>
            <Tabs
              stretch
              secondary
              handleSelectedIndex={(index) => this.handleSelectedIndexClicked(index)}
              selectedIndex={selectedReportDetailsDateRange}
            >
              <Tab testID="tab_report_lastWeek_reportStatementDetails_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => (messages['app.chedelivery.reports.lastweektab'] + ` (` + totalDocs7Days + `)`)} />
              <Tab testID="tab_report_lastMonth_reportStatementDetails_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => (messages['app.chedelivery.reports.lastmonthtab'] + ` (` + totalDocs30Days + `)`)} />
              <Tab testID="tab_report_dateRange_reportStatementDetails_test" style={{ fontSize: 16, paddingHorizontal: 0 }} renderLabel={() => (messages['app.chedelivery.reports.dateRangetab'] + customRangeTotalDocs)} />
            </Tabs>

          </View>



          <SortingHeader
            enabled={false}
            showBorder={false}
            messages={messages}
          />

          {showSpinner === true ? <View><LoadingCircle /></View> :
            this.state.isDateRangeSelected &&
            <View className="customReportCalendar" style={{
              height: "90px", width: "40%",
              flexDirection: "row", alignItems: 'center', justifyContent: 'flex-end', float: 'right'
            }}>
              <View style={{
                border: "solid", borderWidth: "1px", borderRadius: "3px", borderColor: '#a7a8aa',
                margin: "20px 20px 15px 15px", width: '300px', float: 'right'
              }}>
                <DatePicker
                  ref={(ref) => this.datepickerRef = ref}
                  showOutsideMonthDays={false}
                  enableYearNavigation
                  enableRangeSelection
                  onChange={this.onChangeRange}
                  value={this.state.value}
                  startDate={moment(DATE_RANGE.DATE)}
                  endDate={moment()}
                  inputDateFormat={'DD MMM YYYY'}
                  selectionStart={this.state.value.from}
                  selectionEnd={this.state.value.to}
                  renderFooter={() => this.customFooter()}
                />
              </View>

            </View>}
          <View>
            <ReportRMDocList />
          </View>

        </div>
      </View >
    );
  }
}
ReportRMDetails.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  reports: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
};

ReportRMDetails.defaultProps = {
  i18n: {},
  reports: {}
};

export default createContainer({

  $queries: {
    edelivery: {
      getUserPreferences: { $call: 'getUserPreferences' },
      showPrompt: true,
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getLastStatements: {
      $call: 'reports.getLastStatements',
    },
    getDocuments: {
      $call: 'reports.getDocuments',
    },
    // setRangeYTD: {
    //     $call: 'reports.setRangeYTD'
    // },
    setDuration: {
      $call: 'reports.setDuration'
    },
    setReportDetailDateRange: {
      $call: 'reports.setReportDetailDateRange'
    },
    setDataForNotificationList: {
      $call: 'reports.setDataForNotificationList'
    },
    fetchDocumentsForCategories: {
      $call: 'reports.fetchDocumentsForCategories'
    },
    reports: {
      showSpinner: true,
      lastMonthStatements: true,
      totalDocs7Days: true,
      totalDocs30Days: true,
      totalDocsCustomRange: true,
      statement: {

      },
      selectedReportDetailsDateRange: true,
      calendar: {
        open: {
          $call: 'open'
        },
        ...CalendarModal.getFragment('calendarModal'),
      },
      startDate: true,
      endDate: true,
      closeDatePicker: true
    },
    setStartDate: { $set: 'reports.startDate' },
    setEndDate: { $set: 'reports.endDate' },
    auth: {
      langCode: true,
    },
    setDatePickerClose: {
      $set: 'reports.closeDatePicker'
    },
  },
})(ReportRMDetails);

